import { useCallback, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useApi } from "./useApi";
import type { EvidenceActivitySummary, EvidenceActivityTrail } from "../types/evidenceActivity";

export interface EvidenceActivityQuery {
  days?: number;
  from?: string;
  to?: string;
  userId?: number;
  processor?: string;
  outcome?: string;
  result?: string;
  q?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  dir?: string;
}

export function useEvidenceActivity(query: EvidenceActivityQuery) {
  const { get, loading } = useApi();
  const [summary, setSummary] = useState<EvidenceActivitySummary | null>(null);
  const [error, setError] = useState<string | null>(null);

  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => { if (value !== undefined && value !== "") params.set(key, String(value)); });
  const search = params.toString();

  useEffect(() => {
    let current = true;
    get<EvidenceActivitySummary>(`/api/admin/evidence-activity/summary?${search}`)
      .then((res) => { if (current) { setSummary(res); setError(null); } })
      .catch((err) => { Sentry.captureException(err); if (current) { setSummary(null); setError("Failed to load evidence activity"); } });
    return () => { current = false; };
  }, [get, search]);

  const loadTrail = useCallback((draftId: number) => get<EvidenceActivityTrail>(`/api/admin/evidence-activity/drafts/${draftId}`), [get]);

  return { summary, error, loading, loadTrail };
}
